type InputValue = string | number | null;

export function fNumber(inputValue: InputValue) {
  const locale = 'fr-FR';

  if (inputValue == null || Number.isNaN(inputValue)) return '';

  const number = Number(inputValue);

  const fm = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number);
  const formattedNumber = fm.replace(',', '  ');

  return formattedNumber;
}
export function formatPrice(price: number) {
  if (price === 0) return '0';
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export const getPrice = (price: number) => {
  const prices = `${formatPrice(price)}`;

  return prices;
};

export const getInitials = (name: string) =>
  name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase();

export const formatPriceM = (priceStr: string) => {
  // Remove spaces and parse as number
  const price = Number(priceStr.replace(/\s/g, ''));

  if (isNaN(price)) return priceStr; // fallback if not a number

  if (price >= 1_000_000) {
    return `${(price / 1_000_000).toFixed(1)}M`;
  } else if (price >= 1_000) {
    return `${(price / 1_000).toFixed(1)}K`;
  }

  return price.toString();
};
